import Vue from 'vue';
import loginServico from '~modulos/login/servico';
import tipoUsuario from '~js/tipo-usuario';

export default {
  name: 'app',
  data() {
    return {
      tituloDaPagina: '',
      botaoAcaoTexto: '',
      botaoAcaoLink: '',
      filtrosBag: [],
      botaoAcaoMostrar: true,
      animacaoPadrao: 'fadeInUp',
      botaoRetrocederMostrar: false,
      botaoRetrocederRota: '',
    }
  },
  created() {
    let _this = this;

    Vue.http.interceptors.push(function (request, next) {
      request.headers.set('Authorization', Vue.storage.token());

      next(response => {
        if (response.status === 401) {
          _this.$storage.limpar();

          _this.$router.push('/login');
        }
      });
    });

    if (this.$route.matched.some(rota => rota.meta.auth)) {
      loginServico
        .usuarioLogado()
        .catch((err) => {
          this.$storage.limpar();
          this.$router.push('/login');
        });
    }
  },
  mounted() {
    this.$events.on('logout', () => {
      loginServico.logout()
        .then(() => {
          let usuario = this.$storage.usuario();
          
          this.$storage.limpar();

          if (usuario.tipoUsuario === tipoUsuario.Fornecedor || usuario.tipoUsuario === tipoUsuario.FornecedorWeb || usuario.tipoUsuario === tipoUsuario.FornecedorWebNovo) {
            this.$router.push('/login/fornecedor');
          } else if (usuario.tipoUsuario === tipoUsuario.PessoaFisica || usuario.tipoUsuario === tipoUsuario.PessoaFisicaWeb || usuario.tipoUsuario === tipoUsuario.PessoaFisicaWebNovo) {
            this.$router.push('/login/pessoa-fisica');
          } else if (usuario.tipoUsuario === tipoUsuario.Aluno) {
            this.$router.push('/login/aluno');
          } else if (usuario.tipoUsuario === tipoUsuario.Funcionario) {
            this.$router.push('/login/funcionario');
          } else if (usuario.tipoUsuario === tipoUsuario.Importacao) {
            this.$router.push('/login/importacao');
          } else if (usuario.tipoUsuario === tipoUsuario.AcessoEspecial) {
            this.$router.push('/login/acesso-especial');
          } else if (usuario.tipoUsuario === tipoUsuario.UsuarioChat) {
            this.$router.push('/login/usuario-chat');
          } else {
            this.$router.push('/login');
          }
        });
    });

    let _this = this;

    _this.$nextTick(function () {
      _this.collapseLink();
    });
  },
  methods: {
    collapseLink() {
      $('.collapse-link').on('click', function () {
        let ibox = $(this).closest('div.ibox');
        let button = $(this).find('i');
        let content = ibox.children('.ibox-content');
        content.slideToggle(200);
        button.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        ibox.toggleClass('').toggleClass('border-bottom');
        setTimeout(function () {
          ibox.resize();
          ibox.find('[id^=map-]').resize();
        }, 50);
      });
    },
    carregarScripts() {
      let _this = this;

      _this.$nextTick(function () {
        _this.collapseLink();
      });
    }
  },
  watch: {
    '$route': 'carregarScripts'
  }
}



// WEBPACK FOOTER //
// ./FrontEnd/app.js